import { SVGIcon } from "@faire/slate-icons/SVGIcon";
import type { SVGIconProps } from "@faire/slate-icons/types";
import React from "react";

/**
 * Insider key glyph. Not available in `@faire/slate-icons`, so the path is
 * lifted from the shared `DiscoveryProductTile` which draws the same mark on
 * the "Free shipping with Insider" line.
 *
 * Fill is left unset so it inherits `currentColor` from the icon wrapper, which
 * lets Slate's FilterToggle recolor it between rest and applied states.
 */
export const InsiderKeyIcon: React.FC<SVGIconProps> = (props) => (
  <SVGIcon {...props} viewBox="0 0 16 16">
    <path
      clipRule="evenodd"
      d="M8.874 8A4.002 4.002 0 0 1 1 7a4 4 0 0 1 7.874-1H15v3.75h-3V8zM5 9.222a2.222 2.222 0 1 0 0-4.444 2.222 2.222 0 0 0 0 4.444"
      fillRule="evenodd"
    />
  </SVGIcon>
);

/**
 * Top Shop shield. Drawn as strokes rather than fills to match the outline
 * weight of the stroke-based icons in `@faire/slate-icons`.
 */
export const TopShopShieldIcon: React.FC<SVGIconProps> = (props) => (
  <SVGIcon {...props} viewBox="0 0 16 16">
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
    >
      <path d="M8 1.9 3 3.5v4c0 2.9 2 5.6 5 6.6 3-1 5-3.7 5-6.6v-4L8 1.9Z" />
      <path d="m5.9 7.8 1.6 1.7 2.9-3.2" />
    </g>
  </SVGIcon>
);
